module.exports = __webpack_public_path__ + "img/40f3f01.png";